<ul>
    <li *ngFor="let item of icons; let i = index; ">
        <div fxLayoutAlign="center center" fxLayout="column">
            <span
              class="social-icon-holder circle border"
              *ngIf="!item.iconUrl || item.forceDefaultLogo"
              (click)="handleIconSelected(item)"
              [title]="item.label || ''">
              <span class="social-icon" [ngClass]="item.iconClass || 'cidaas-icon-provider'"></span>
            </span>
            <span
              class="social-icon-holder compatible"
              *ngIf="item.iconUrl && !item.forceDefaultLogo"
              (click)="handleIconSelected(item)"
              [title]="item.label"
            >
              <img alt="logo" [src]="item.iconUrl" (error)="handleImageError($event,i) "/>
            </span>
            <label style="padding: 5px; margin-top: 5px;">{{item.label | titlecase}}</label>
          </div>
      </li>
</ul>
